'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.errorState.${key}`;
const MenuErrorState = () => {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "menus-error-state",
    children: /*#__PURE__*/_jsx(UIErrorMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('header')
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('body')
        })
      })
    })
  });
};
export default MenuErrorState;